import { CreateSlice } from './index'

export type DataTableState = {
    dataTable: {
        pagination: {
            pageSize: number | undefined
            setPageSize: (pageSize: number) => void
        }
    }
}

export const createDataTableSlice: CreateSlice<DataTableState> = (
    set,
    get,
) => ({
    dataTable: {
        pagination: {
            pageSize: undefined,
            setPageSize: (pageSize: number) => {
                set({
                    ...get(),
                    dataTable: {
                        ...get().dataTable,
                        pagination: {
                            ...get().dataTable.pagination,
                            pageSize,
                        },
                    },
                })
            },
        },
    },
})
